module.exports = __webpack_public_path__ + "static/media/finbit.314b8040.png";